export enum GamesPlatformWebView {
  Steam = "steam",
  Quest = "quest",
  Pico = "pico",
  Psvr2 = "psvr2",
  Pc = "pc",
  Simracing = "simracing",
}
